
// const BASE = 'http://localhost/CODIZN-full-project%20(2)/codizn/backend';

import { BASE_URL } from './env';
const BASE = BASE_URL;   
function getToken() {
  return localStorage.getItem('aurora_admin_token') || '';
}

async function request(url, options = {}) {
  const res = await fetch(url, { credentials: 'include', ...options });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Request failed: ${res.status}`);
  }
  return res.json();
}

function authHeaders(isFormData = false) {
  const headers = { 'Authorization': `Bearer ${getToken()}` };
  if (!isFormData) headers['Content-Type'] = 'application/json';
  return headers;
}

// ── Products ─────────────────────────────────────────────
// export const getProducts = () =>
//   request(`${BASE}/index.php?route=products`, { headers: authHeaders() });

// export const getProducts = (page = 1, limit = 10, filters = {}) => {
//   const params = new URLSearchParams({ page, limit, ...filters });
//   return request(`${BASE}/index.php?route=products&${params}`, { headers: authHeaders() });
// };

// ── Keep this EXACTLY as it was (returns plain array) ──
// export const getProducts = () =>
//   request(`${BASE}/index.php?route=products`, { headers: authHeaders() });
// In api.js — fix getProducts to always return a plain array
export const getProducts = () =>
  request(`${BASE}/index.php?route=products&limit=1000`, { headers: authHeaders() })
    .then(d => Array.isArray(d) ? d : d?.products || []);
// ── New: admin paginated version ──
export const getProductsPaginated = (page = 1, limit = 10, filters = {}) => {
  const params = new URLSearchParams({ page, limit, ...filters });
  return request(`${BASE}/index.php?route=products&${params}`, { headers: authHeaders() });
};

export const getProduct = (id) =>
  request(`${BASE}/index.php?route=products&id=${id}`);

export const createProduct = (data) =>
  request(`${BASE}/index.php?route=products`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const updateProduct = (id, data) =>
  request(`${BASE}/index.php?route=products&id=${id}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify(data),
  });

export const deleteProduct = (id) =>
  request(`${BASE}/index.php?route=products&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Banners ──────────────────────────────────────────────
export const getPublicBanners = () =>
  request(`${BASE}/index.php?route=banners`).catch(() => []);

export const getBanners = () =>
  request(`${BASE}/admin_panel.php?section=banners`, { headers: authHeaders() }).catch(() => []);

export const createBanner = (data) =>
  request(`${BASE}/admin_panel.php?section=banners`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const updateBanner = (id, data) =>
  request(`${BASE}/admin_panel.php?section=banners&id=${id}`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify(data),
  });

export const toggleBanner = (id) =>
  request(`${BASE}/admin_panel.php?section=banners&id=${id}`, {
    method: 'PATCH', headers: authHeaders(),
  });

export const deleteBanner = (id) =>
  request(`${BASE}/admin_panel.php?section=banners&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Orders ───────────────────────────────────────────────
export const placeOrder = (payload) =>
  request(`${BASE}/index.php?route=orders`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

// export const getOrders = () =>
//   request(`${BASE}/index.php?route=orders`, { headers: authHeaders() });
export const getOrders = (page = 1, limit = 10) =>
  request(`${BASE}/index.php?route=orders&page=${page}&limit=${limit}`, { headers: authHeaders() });

export const updateOrderStatus = (ref, status) =>
  request(`${BASE}/index.php?route=orders&id=${ref}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify({ status }),
  });

export const updateOrder = (ref, data) =>
  request(`${BASE}/index.php?route=orders&id=${ref}`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify(data),
  });

export const saveAbandonedCart = (payload) =>
  request(`${BASE}/index.php?route=orders&sub=abandoned`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => null);

// ── Auth ─────────────────────────────────────────────────
export const adminLogin = (email, password) =>
  request(`${BASE}/admin_login.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

export const adminLogout = () =>
  request(`${BASE}/logout.php`, {
    method: 'POST', headers: authHeaders(),
  }).catch(() => null);

// ── Admin Dashboard ──────────────────────────────────────
export const getDashboard = () =>
  request(`${BASE}/admin_panel.php?section=dashboard`, { headers: authHeaders() });

// ── Enquiries ────────────────────────────────────────────
export const submitEnquiry = (data) =>
  request(`${BASE}/index.php?route=enquiries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const getEnquiries = () =>
  request(`${BASE}/admin_panel.php?section=enquiries`, { headers: authHeaders() });

export const updateEnquiryStatus = (id, status) =>
  request(`${BASE}/admin_panel.php?section=enquiries&id=${id}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify({ status }),
  });

export const deleteEnquiry = (id) =>
  request(`${BASE}/admin_panel.php?section=enquiries&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Consignments ─────────────────────────────────────────
export const submitConsignment = (data) =>
  request(`${BASE}/index.php?route=consignments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const getConsignments = () =>
  request(`${BASE}/admin_panel.php?section=consignments`, { headers: authHeaders() });

// ── Promo Codes ──────────────────────────────────────────
// export const validatePromo = async (code) => {
//   try {
//     return await request(`${BASE}/index.php?route=promo&sub=validate`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ code }),
//     });
//   } catch {
//     return { ok: false, error: 'Invalid code' };
//   }
// };
// This should already be correct in your api.js:
export const validatePromo = async (payload) => {
  try {
    return await request(`${BASE}/index.php?route=promo&sub=validate`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),   // payload = { code, items, subtotal }
    });
  } catch (e) {
    throw e;  // let the caller handle it
  }
};

export const usePromoCode = (code) =>
  request(`${BASE}/index.php?route=promo&sub=use`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code }),
  }).catch(() => null);

// export const getPromoCodes = () =>
//   request(`${BASE}/admin_panel.php?section=promo`, { headers: authHeaders() });

export const getPromoCodes = () =>
  request(`${BASE}/index.php?route=promo`, { headers: authHeaders() });

export const createPromoCode = (data) =>
  request(`${BASE}/admin_panel.php?section=promo`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const deletePromoCode = (id) =>
  request(`${BASE}/index.php?route=promo&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Settings ─────────────────────────────────────────────
export const getSettings = () =>
  request(`${BASE}/index.php?route=settings`).catch(() => ({}));


export const updateSettings = (data) =>
  request(`${BASE}/admin_panel.php?section=settings`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify(data),
  });

// ── Newsletter ───────────────────────────────────────────
export const subscribeNewsletter = (email) =>
  request(`${BASE}/index.php?route=newsletter`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });

export const getNewsletterList = () =>
  request(`${BASE}/admin_panel.php?section=newsletter`, { headers: authHeaders() });

// ── Blogs ────────────────────────────────────────────────
export const getBlogs = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return request(`${BASE}/blogs.php${q ? '?' + q : ''}`);
};

export const getBlogDetail = (idOrSlug) => {
  const isNum = !isNaN(idOrSlug);
  const q = isNum ? `id=${idOrSlug}` : `slug=${idOrSlug}`;
  return request(`${BASE}/blogsdetails.php?${q}`);
};

export const createBlog = (data) =>
  request(`${BASE}/blogs.php`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const updateBlog = (id, data) =>
  request(`${BASE}/blogs.php?id=${id}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify(data),
  });

export const deleteBlog = (id) =>
  request(`${BASE}/blogs.php?id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Contacts ─────────────────────────────────────────────
export const saveContact = (data) =>
  request(`${BASE}/save_contact.php`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const getContacts = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  return request(`${BASE}/get_contacts.php${q ? '?' + q : ''}`, { headers: authHeaders() });
};

export const updateContactStatus = (id, status) =>
  request(`${BASE}/admin_panel.php?section=contacts&id=${id}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify({ status }),
  });

// ── Image Upload ─────────────────────────────────────────
export const uploadImage = (file) => {
  const form = new FormData();
  form.append('image', file);
  return request(`${BASE}/upload.php`, {
    method: 'POST',
    headers: authHeaders(true),
    body: form,
  });
};

// ── Categories ───────────────────────────────────────────
export const getCategories = () =>
  request(`${BASE}/admin_panel.php?section=categories`, { headers: authHeaders() });

export const createCategory = (data) =>
  request(`${BASE}/admin_panel.php?section=categories`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const updateCategory = (id, data) =>
  request(`${BASE}/admin_panel.php?section=categories&id=${id}`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify(data),
  });

export const toggleCategoryHome = (id) =>
  request(`${BASE}/admin_panel.php?section=categories&id=${id}`, {
    method: 'PATCH', headers: authHeaders(),
  });

export const deleteCategory = (id) =>
  request(`${BASE}/admin_panel.php?section=categories&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Public: only show_home=1 categories (used by Header dropdown + homepage) ──
export const getPublicCategories = () =>
  request(`${BASE}/index.php?route=categories`).catch(() => []);

// ── Public: ALL categories (used by /categories page) ────
export const getPublicAllCategories = () =>
  request(`${BASE}/index.php?route=all_categories`).catch(() => []);

// ── Featured Products ────────────────────────────────────
export const getFeaturedProducts = () =>
  request(`${BASE}/index.php?route=featured`).catch(() => []);

export const getAdminFeatured = () =>
  request(`${BASE}/admin_panel.php?section=featured`, { headers: authHeaders() });

export const addFeaturedProduct = (product_id) =>
  request(`${BASE}/admin_panel.php?section=featured`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify({ product_id }),
  });

export const removeFeaturedProduct = (product_id) =>
  request(`${BASE}/admin_panel.php?section=featured&id=${product_id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Admin Users ──────────────────────────────────────────
export const getAdminUsers = () =>
  request(`${BASE}/admin_panel.php?section=users`, { headers: authHeaders() });

export const createAdminUser = (data) =>
  request(`${BASE}/admin_panel.php?section=users`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const deleteAdminUser = (id) =>
  request(`${BASE}/admin_panel.php?section=users&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

export const updateAdminUser = (id, data) =>
  request(`${BASE}/admin_panel.php?section=users&id=${id}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify(data),
  });

// ── Clients ──────────────────────────────────────────────
export const getClients = () =>
  request(`${BASE}/admin_panel.php?section=clients`, { headers: authHeaders() });

export const createClient = (data) =>
  request(`${BASE}/admin_panel.php?section=clients`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const updateClient = (id, data) =>
  request(`${BASE}/admin_panel.php?section=clients&id=${id}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify(data),
  });

export const deleteClient = (id) =>
  request(`${BASE}/admin_panel.php?section=clients&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Brands ───────────────────────────────────────────────
export const getBrands = () =>
  request(`${BASE}/admin_panel.php?section=brands`, { headers: authHeaders() });

export const createBrand = (data) =>
  request(`${BASE}/admin_panel.php?section=brands`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const updateBrand = (id, data) =>
  request(`${BASE}/admin_panel.php?section=brands&id=${id}`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify(data),
  });

export const deleteBrand = (id) =>
  request(`${BASE}/admin_panel.php?section=brands&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// ── Public: ALL brands (used by /brands page + Header dropdown) ──
export const getPublicBrands = () =>
  request(`${BASE}/index.php?route=brands`).catch(() => []);

// ── Testimonials ─────────────────────────────────────────────
export const getPublicTestimonials = () =>
  request(`${BASE}/index.php?route=testimonials`).catch(() => []);

export const getAdminTestimonials = () =>
  request(`${BASE}/admin_panel.php?section=testimonials`, { headers: authHeaders() });

export const createTestimonial = (data) =>
  request(`${BASE}/admin_panel.php?section=testimonials`, {
    method: 'POST', headers: authHeaders(), body: JSON.stringify(data),
  });

export const updateTestimonial = (id, data) =>
  request(`${BASE}/admin_panel.php?section=testimonials&id=${id}`, {
    method: 'PUT', headers: authHeaders(), body: JSON.stringify(data),
  });

export const toggleTestimonial = (id, active) =>
  request(`${BASE}/admin_panel.php?section=testimonials&id=${id}`, {
    method: 'PATCH', headers: authHeaders(), body: JSON.stringify({ active }),
  });

export const deleteTestimonial = (id) =>
  request(`${BASE}/admin_panel.php?section=testimonials&id=${id}`, {
    method: 'DELETE', headers: authHeaders(),
  });

export const submitLead = (data) =>
  request(`${BASE}/index.php?route=leads`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });

export const getLeads = () =>
  request(`${BASE}/admin_panel.php?section=leads`, { headers: authHeaders() });

export const deleteOrder = (ref) =>
  request(`${BASE}/index.php?route=orders&id=${ref}`, {
    method: 'DELETE', headers: authHeaders(),
  });

// Add a new public products function
export const getPublicProducts = () =>
  request(`${BASE}/index.php?route=products&limit=1000&public=1`, { headers: authHeaders() })
    .then(d => Array.isArray(d) ? d : d?.products || []);